<mat-paginator [ngClass]="options && options.paginatorClass"
  [hidePageSize]="options && options.hidePageSize"
  *ngIf="pagination"
  [length]="pagination.totalItems"
  [pageSize]="pagination.size"
  [pageIndex]="pagination.page - pageIndexOffset"
  [pageSizeOptions]="pageSizeOptions"
  (page)="onPageChange($event)">
</mat-paginator>